//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { MODAL_WRAPPER__DISPLAY } from '@/scripts/constants/css-classes'
import { FocusTrap } from 'focus-trap-vue'
export default {
  name: 'rb-modal',
  components: {
    FocusTrap,
  },
  props: {
    name: {
      type: String,
      default() {
        return `model-${new Date().getTime()}`
      },
    },
    show: {
      type: Boolean,
      default: false,
    },
    backdropDisabled: {
      type: Boolean,
      default: false,
    },
    handleClose: {
      type: Function,
      default: () => ({}),
    },
    hideCloseIcon: {
      type: Boolean,
      default: false,
    },
    dataElementId: {
      type: String,
      default: 'X_X_Modal',
    },
    dataElementIdCloseButton: {
      type: String,
      default: 'X_X_Modal_Close',
    },
    modalClass: {
      type: String,
      default: '',
    },
    modalClassHtmlTag: {
      type: String,
      default: '',
    },
    modalClassContainer: {
      type: String,
      default: '',
    },
    modalWrapperClass: {
      type: String,
      default: '',
    },
    modalClassTheme: {
      type: String,
      default: '',
    },
    focusEnabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show(value, oldValue) {
      const element = document.getElementsByClassName(`modal-wrapper--${this.modalWrapperClass}`)[0]
      if (value === true && oldValue === false) {
        element?.classList.add(MODAL_WRAPPER__DISPLAY)
        this.$modal.push(this.name)
        if (this.focusEnabled) {
          this.focusButton()
        }
      } else if (value === false && oldValue === true) {
        element?.classList.remove(MODAL_WRAPPER__DISPLAY)
        this.$modal.pop(this.name)
      }
    },
  },
  methods: {
    addModalNameClass() {
      if (this.modalClass) {
        document.body.classList.add(this.modalClass)
      }
      if (this.modalClassHtmlTag) {
        document.documentElement.classList.add(this.modalClassHtmlTag)
      }
    },
    removeModalNameClass() {
      if (this.modalClass) {
        document.body.classList.remove(this.modalClass)
      }
      if (this.modalClassHtmlTag) {
        document.documentElement.classList.remove(this.modalClassHtmlTag)
      }
    },
    onBeforeOpen() {
      this.addModalNameClass()
    },
    onAfterClose() {
      this.removeModalNameClass()
    },
    onHandleClose() {
      this.$props.handleClose()
      clearTimeout(this.STClose)
      this.STClose = setTimeout(() => {
        this.onAfterClose()
      }, 500)
    },
    emptyClick(e) {
      e.stopPropagation()
    },
    focusButton() {
      this.$nextTick(() => {
        if (this.$refs.closeModal) {
          this.$refs.closeModal.focus()
        }
      })
    },
  },
}
